import { defineComponent as _defineComponent } from 'vue'
import {
  TUIGlobal,
  TUITranslateService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
  TUIChatService,
} from "@tencentcloud/chat-uikit-engine";
import { ref, defineEmits } from "../../../../adapter-vue";
import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import wordsIcon from "../../../../assets/icon/words.svg";
import { wordsList } from "../../utils/wordsList";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isPC = ref(TUIGlobal.getPlatform() === "pc");
const isUniFrameWork = ref(typeof uni !== 'undefined');
const currentConversation = ref<IConversationModel>();
const container = ref();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const selectWord = (item: any) => {
  const options = {
    to:
      currentConversation?.value?.groupProfile?.groupID ||
      currentConversation?.value?.userProfile?.userID,
    conversationType: currentConversation?.value?.type,
    payload: {
      text: item.value,
    },
  } as SendMessageParams;
  TUIChatService.sendTextMessage(options);
  // 提交后关闭 dialog
  // close dialog after submit evaluate
  container?.value?.toggleDialogDisplay(false);
};

const closeDialog = () => {
  container?.value?.toggleDialogDisplay(false);
};

return { __sfc: true,isPC, isUniFrameWork, currentConversation, container, selectWord, closeDialog, TUITranslateService, ToolbarItemContainer, wordsIcon, wordsList }
}

})